import React from 'react';
import Icon from '@ant-design/icons';

// Tabler Icons "language", MIT license.
const TranslateLanguageSvg = () => (
    <svg
        fill="none"
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M9 6.371c0 4.418 -2.239 6.629 -5 6.629" />
        <path d="M4 6.371h7" />
        <path d="M5 9c0 2.144 2.252 3.908 6 4" />
        <path d="M12 20l4 -9l4 9" />
        <path d="M19.1 18h-6.2" />
        <path d="M6.694 3l.793 .582" />
    </svg>
);

const TranslateLanguageIcon = (props) => {
    return <Icon component={ TranslateLanguageSvg } className={ props.className } style={ props.style } />;
};

export default TranslateLanguageIcon;
